module.exports = __webpack_public_path__ + "img/ManHoleDownAgainstFlow.5b869c85.svg";